import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/globals.css";
import "./styles/funding-flash-animations.css";
import { setupChunkErrorHandler } from "./utils/chunkErrorHandler";

// Handle chunk load failures from new deployments before they bubble up to error boundaries
setupChunkErrorHandler();

// Temporarily disable StrictMode to prevent double-mounting issues
// StrictMode causes components to mount/unmount/remount in development
// which cancels in-flight requests and causes dashboard switching issues
ReactDOM.createRoot(document.getElementById("root")!).render(
  <App />
);
